









import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

const on = (function() {
	return function(element: any, event: any, handler: any) {
		if (element && event && handler) {
			element.addEventListener(event, handler, false);
		}
	};
})();

const off = (function() {
	return function(element: any, event: any, handler: any) {
		if (element && event) {
			element.removeEventListener(event, handler, false);
		}
	};
})();

const getScroll = function(target: any, top?: boolean): number {
	const prop = top ? "pageYOffset" : "pageXOffset";
	const method = top ? "scrollTop" : "scrollLeft";
	let ret = target[prop];
	if (typeof ret !== "number") {
		ret = (window as any).document.documentElement[method];
	}
	return ret;
};
const getOffset = function(element: HTMLElement): any {
	const rect = element.getBoundingClientRect();
	const scrollTop = getScroll(window, true);
	const scrollLeft = getScroll(window);
	const docEl = window.document.body;
	const clientTop = docEl.clientTop || 0;
	const clientLeft = docEl.clientLeft || 0;
	return {
		top: rect.top + scrollTop - clientTop,
		left: rect.left + scrollLeft - clientLeft
	};
};

@Component
export default class ElAffix extends Vue {
	@Prop({ type: [Number], default: 0 }) offsetTop!: number;
	@Prop({ type: [Number] }) offsetBottom!: number;

	private affix: boolean = false;
	private styles: any = {};
	private slot: boolean = false;
	private slotStyle: any = {};

	get offsetType(): string {
		let type = "top";
		if (Number(this.offsetBottom) >= 0) {
			type = "bottom";
		}
		return type;
	}
	get classes(): Array<any> {
		return [
			{
				active: this.affix
			}
		];
	}

	mounted() {
		on(window, "scroll", this.handleScroll);
		on(window, "resize", this.handleScroll);
		this.$nextTick(() => {
			this.handleScroll();
		});
	}
	beforeDestroy() {
		off(window, "scroll", this.handleScroll);
		off(window, "resize", this.handleScroll);
	}

	handleScroll() {
		const affix = this.affix;
		const scrollTop = getScroll(window, true);
		const elOffset = getOffset(this.$el as HTMLElement);
		const windowHeight = window.innerHeight;
		const elHeight = this.$el.getElementsByTagName("div")[0].offsetHeight;
		// Fixed Top
		if (
			elOffset.top - Number(this.offsetTop) < scrollTop &&
			this.offsetType == "top" &&
			!affix
		) {
			this.affix = true;
			this.slotStyle = {
				width: (this.$refs.point as HTMLElement).clientWidth + "px",
				height: (this.$refs.point as HTMLElement).clientHeight + "px"
			};
			this.slot = true;
			this.styles = {
				top: `${Number(this.offsetTop)}px`,
				left: `${elOffset.left}px`,
				width: `${(this.$el as HTMLElement).offsetWidth}px`
			};
			this.$emit("on-change", true);
		} else if (
			elOffset.top - Number(this.offsetTop) > scrollTop &&
			this.offsetType == "top" &&
			affix
		) {
			this.slot = false;
			this.slotStyle = {};
			this.affix = false;
			this.styles = null;
			this.$emit("on-change", false);
		}
		// Fixed Bottom
		if (
			elOffset.top + Number(this.offsetBottom) + elHeight >
				scrollTop + windowHeight &&
			this.offsetType == "bottom" &&
			!affix
		) {
			this.affix = true;
			this.styles = {
				bottom: `${Number(this.offsetBottom)}px`,
				left: `${elOffset.left}px`,
				width: `${(this.$el as HTMLElement).offsetWidth}px`
			};
			this.$emit("on-change", true);
		} else if (
			elOffset.top + Number(this.offsetBottom) + elHeight <
				scrollTop + windowHeight &&
			this.offsetType == "bottom" &&
			affix
		) {
			this.affix = false;
			this.styles = null;
			this.$emit("on-change", false);
		}
	}
}
